export default __webpack_public_path__ + "static/media/image.c68671fd.png";